import React from 'react';
import PropTypes from 'prop-types';
// Models
import mDeviceLog from 'models/deviceLog';
// HOCs
import wrapListFilters from 'hocs/WrapListFilters';
// Custom
import { listFeatureSearchFieldShape, listFilterShape } from 'constants/PropTypesShapes';
import { dateGenerator } from 'utils/DateUtils';
// Components
import FiltersTemplate from 'components/templates/FiltersTemplate';
import BaseListFilter from 'components/filters/BaseListFilter';
import DateFilter from 'components/filters/DateFilter';
import ItemsSelectFieldFilter from 'components/filters/ItemsSelectFieldFilter';
import TextFieldFilter from 'components/filters/TextFieldFilter';

const LogFilters = ({
  disabled, advanced, nbFiltersApplied, searchFields, field, filters,
  isFieldDisplayable, onFieldChange, onFilterFieldChange, onReinit, onSwitch,
}) => {
  const {
    type, begin, end, tag, level, origin, desc,
  } = filters;
  // Dates
  const beginDate = dateGenerator.date(begin.value);
  const endDate = dateGenerator.date(end.value);

  return (
    <FiltersTemplate
      disabled={disabled}
      advanced={advanced}
      nbFiltersApplied={nbFiltersApplied}
      onReinit={onReinit}
      onSwitch={onSwitch}
    >
      <div className="row m-0 pb-3">
        {!advanced && (
          <div className="col-12 col-md-4 col-xl-3">
            <BaseListFilter
              field={field}
              searchFields={searchFields}
              onChange={onFieldChange}
            />
          </div>
        )}
        {isFieldDisplayable('type') && (
          <div className="col-12 col-md-4 col-xl-3">
            <ItemsSelectFieldFilter
              labelId="field.type"
              value={type.value}
              items={mDeviceLog.typesList}
              onChange={(value) => onFilterFieldChange('type', value)}
            />
          </div>
        )}
        {isFieldDisplayable('begin') && (
          <div className="col-12 col-md-4 col-xl-3">
            <DateFilter
              labelId="field.afterDate"
              type="begin"
              value={beginDate}
              onChange={(value) => onFilterFieldChange('begin', value)}
            />
          </div>
        )}
        {isFieldDisplayable('end') && (
          <div className="col-12 col-md-4 col-xl-3">
            <DateFilter
              labelId="field.beforeDate"
              type="end"
              value={endDate}
              onChange={(value) => onFilterFieldChange('end', value)}
            />
          </div>
        )}
        {isFieldDisplayable('tag') && (
          <div className="col-12 col-md-4 col-xl-3">
            <ItemsSelectFieldFilter
              labelId="field.tag"
              value={tag.value}
              items={mDeviceLog.tagsList}
              onChange={(value) => onFilterFieldChange('tag', value)}
            />
          </div>
        )}
        {isFieldDisplayable('level') && (
          <div className="col-12 col-md-4 col-xl-3">
            <ItemsSelectFieldFilter
              labelId="field.level"
              value={level.value}
              items={mDeviceLog.levelsList}
              onChange={(value) => onFilterFieldChange('level', value)}
            />
          </div>
        )}
        {isFieldDisplayable('origin') && (
          <div className="col-12 col-md-4 col-xl-3">
            <ItemsSelectFieldFilter
              labelId="field.origin"
              value={origin.value}
              items={mDeviceLog.originsList}
              onChange={(value) => onFilterFieldChange('origin', value)}
            />
          </div>
        )}
        {isFieldDisplayable('desc') && (
          <div className="col-12 col-md-4 col-xl-3">
            <TextFieldFilter
              label="field.desc"
              value={desc.value}
              onChange={(value) => onFilterFieldChange('desc', value)}
            />
          </div>
        )}
      </div>
    </FiltersTemplate>
  );
};

LogFilters.propTypes = {
  // From HOC
  disabled: PropTypes.bool.isRequired,
  advanced: PropTypes.bool.isRequired,
  nbFiltersApplied: PropTypes.number.isRequired,
  searchFields: PropTypes.arrayOf(listFeatureSearchFieldShape).isRequired,
  field: PropTypes.string.isRequired,
  filters: PropTypes.shape({
    type: listFilterShape,
    begin: listFilterShape,
    end: listFilterShape,
    tag: listFilterShape,
    level: listFilterShape,
    origin: listFilterShape,
    desc: listFilterShape,
  }).isRequired,
  isFieldDisplayable: PropTypes.func.isRequired,
  onFieldChange: PropTypes.func.isRequired,
  onFilterFieldChange: PropTypes.func.isRequired,
  onReinit: PropTypes.func.isRequired,
  onSwitch: PropTypes.func.isRequired,
};

module.exports = wrapListFilters(mDeviceLog.listFeatures.searchFields)(LogFilters);



// WEBPACK FOOTER //
// ./routes/app/routes/devices/assets/logs/LogFilters.js